import { Action } from '@ngrx/store';

export enum MasterActionTypes {
  LoadMaster = '[Master] Load Master',
  MasterLoaded = '[Master] Master Loaded',
  MasterLoadError = '[Master] Master Load Error',
  CreateShipper = '[Master] Create Shipper',
  ShipperCreated = '[Master] Shipper Created',
  CreateShipperError = '[Master] Create Shipper Error',
  LoadShipper = '[Master] Load Shipper',
  ShipperLoaded = '[Master] Shipper Loaded',
  ShipperLoadError = '[Master] Shipper Load Error',
  UpdateShipper = '[Master] Update Shipper',
  ShipperUpdated = '[Master] Shipper Updated',
  UpdateShipperError = '[Master] Update Shipper Error',
  ClearStore = '[Master] Clear Store',
  CreateConsignee = '[Master] Create Consignee',
  ConsigneeCreated = '[Master] Consignee Created',
  CreateConsigneeError = '[Master] Create Consignee Error',
  LoadConsignee = '[Master] Load Consignee',
  ConsigneeLoaded = '[Master] Consignee Loaded',
  ConsigneeLoadError = '[Master] Consignee Load Error',
  UpdateConsignee = '[Master] Update Consignee',
  ConsigneeUpdated = '[Master] Consignee Updated',
  UpdateConsigneeError = '[Master] Update Consignee Error',
  CreateNotify = '[Master] Create Notify',
  NotifyCreated = '[Master] Notify Created',
  CreateNotifyError = '[Master] Create Notify Error',
  LoadNotify = '[Master] Load Notify',
  NotifyLoaded = '[Master] Notify Loaded',
  NotifyLoadError = '[Master] Notify Load Error',
  UpdateNotify = '[Master] Update Notify',
  NotifyUpdated = '[Master] Notify Updated',
  UpdateNotifyError = '[Master] Update Notify Error',
  CreateDeliveryAgent = '[Master] Create Delivery Agent',
  DeliveryAgentCreated = '[Master] Delivery Agent Created',
  CreateDeliveryAgentError = '[Master] Create Delivery Agent Error',
  LoadDeliveryAgent = '[Master] Load Delivery Agent',
  DeliveryAgentLoaded = '[Master] Delivery Agent Loaded',
  DeliveryAgentLoadError = '[Master] Delivery Agent Load Error',
  UpdateDeliveryAgent = '[Master] Update Delivery Agent',
  DeliveryAgentUpdated = '[Master] Delivery Agent Updated',
  UpdateDeliveryAgentError = '[Master] Update Delivery Agent Error',
  DeleteEntity = '[Master] Delete Entity',
  EntityDeleted = '[Master] Entity Deleted',
  DeleteEntityError = '[Master] Delete Entity Error',
  CreateAirportCode = '[Master] Create Airport Code',
  AirportCodeCreated = '[Master] Airport Code Created',
  CreateAirportCodeError = '[Master] Create Airport Code Error',
  LoadAirportCode = '[Master] Load Airport Code',
  AirportCodeLoaded = '[Master] Airport Code Loaded',
  AirportCodeLoadError = '[Master] Airport Code Load Error',
  CreateCarrierCode = '[Master] Create Carrier Code',
  CarrierCodeCreated = '[Master] Carrier Code Created',
  CreateCarrierCodeError = '[Master] Create Carrier Code Error',
  LoadCarrierCode = '[Master] Load Carrier Code',
  CarrierCodeLoaded = '[Master] Carrier Code Loaded',
  CarrierCodeLoadError = '[Master] Carrier Code Load Error',
  CreateDestinationAirport = '[Master] Create Destination Airport',
  DestinationAirportCreated = '[Master] Destination Airport Created',
  CreateDestinationAirportError = '[Master] Create Destination Airport Error',
  LoadDestinationAirport = '[Master] Load Destination Airport',
  DestinationAirportLoaded = '[Master] Destination Airport Loaded',
  DestinationAirportLoadError = '[Master] Destination Airport Load Error',
  CreateAirline = '[Master] Create Airline',
  AirlineCreated = '[Master] Airline Created',
  CreateAirlineError = '[Master] Create Airline Error',
  LoadAirline = '[Master] Load Airline',
  AirlineLoaded = '[Master] Airline Loaded',
  AirlineLoadError = '[Master] Airline Load Error',
}

export class LoadMaster implements Action {
  readonly type = MasterActionTypes.LoadMaster;
}

export class MasterLoadError implements Action {
  readonly type = MasterActionTypes.MasterLoadError;
  constructor(public payload: any) {}
}

export class MasterLoaded implements Action {
  readonly type = MasterActionTypes.MasterLoaded;
  constructor(public payload: any) {}
}

export class CreateShipper implements Action {
  readonly type = MasterActionTypes.CreateShipper;
  constructor(public payload: any) {}
}

export class ShipperCreated implements Action {
  readonly type = MasterActionTypes.ShipperCreated;
  constructor(public payload: any) {}
}

export class CreateShipperError implements Action {
  readonly type = MasterActionTypes.CreateShipperError;
  constructor(public payload: any) {}
}

export class LoadShipper implements Action {
  readonly type = MasterActionTypes.LoadShipper;
}

export class ShipperLoaded implements Action {
  readonly type = MasterActionTypes.ShipperLoaded;
  constructor(public payload: any) {}
}

export class ShipperLoadError implements Action {
  readonly type = MasterActionTypes.ShipperLoadError;
  constructor(public payload: any) {}
}

export class UpdateShipper implements Action {
  readonly type = MasterActionTypes.UpdateShipper;
  constructor(public payload: any, public id: string) {}
}

export class ShipperUpdated implements Action {
  readonly type = MasterActionTypes.ShipperUpdated;
  constructor(public payload: any) {}
}

export class UpdateShipperError implements Action {
  readonly type = MasterActionTypes.UpdateShipperError;
  constructor(public payload: any) {}
}

export class ClearStore implements Action {
  readonly type = MasterActionTypes.ClearStore;
}

export class CreateConsignee implements Action {
  readonly type = MasterActionTypes.CreateConsignee;
  constructor(public payload: any) {}
}

export class ConsigneeCreated implements Action {
  readonly type = MasterActionTypes.ConsigneeCreated;
  constructor(public payload: any) {}
}

export class CreateConsigneeError implements Action {
  readonly type = MasterActionTypes.CreateConsigneeError;
  constructor(public payload: any) {}
}

export class LoadConsignee implements Action {
  readonly type = MasterActionTypes.LoadConsignee;
}

export class ConsigneeLoaded implements Action {
  readonly type = MasterActionTypes.ConsigneeLoaded;
  constructor(public payload: any) {}
}

export class ConsigneeLoadError implements Action {
  readonly type = MasterActionTypes.ConsigneeLoadError;
  constructor(public payload: any) {}
}

export class UpdateConsignee implements Action {
  readonly type = MasterActionTypes.UpdateConsignee;
  constructor(public payload: any, public id: string) {}
}

export class ConsigneeUpdated implements Action {
  readonly type = MasterActionTypes.ConsigneeUpdated;
  constructor(public payload: any) {}
}

export class UpdateConsigneeError implements Action {
  readonly type = MasterActionTypes.UpdateConsigneeError;
  constructor(public payload: any) {}
}

export class CreateNotify implements Action {
  readonly type = MasterActionTypes.CreateNotify;
  constructor(public payload: any) {}
}

export class NotifyCreated implements Action {
  readonly type = MasterActionTypes.NotifyCreated;
  constructor(public payload: any) {}
}

export class CreateNotifyError implements Action {
  readonly type = MasterActionTypes.CreateNotifyError;
  constructor(public payload: any) {}
}

export class LoadNotify implements Action {
  readonly type = MasterActionTypes.LoadNotify;
}

export class NotifyLoaded implements Action {
  readonly type = MasterActionTypes.NotifyLoaded;
  constructor(public payload: any) {}
}

export class NotifyLoadError implements Action {
  readonly type = MasterActionTypes.NotifyLoadError;
  constructor(public payload: any) {}
}

export class UpdateNotify implements Action {
  readonly type = MasterActionTypes.UpdateNotify;
  constructor(public payload: any, public id: string) {}
}

export class NotifyUpdated implements Action {
  readonly type = MasterActionTypes.NotifyUpdated;
  constructor(public payload: any) {}
}

export class UpdateNotifyError implements Action {
  readonly type = MasterActionTypes.UpdateNotifyError;
  constructor(public payload: any) {}
}

export class CreateDeliveryAgent implements Action {
  readonly type = MasterActionTypes.CreateDeliveryAgent;
  constructor(public payload: any) {}
}

export class DeliveryAgentCreated implements Action {
  readonly type = MasterActionTypes.DeliveryAgentCreated;
  constructor(public payload: any) {}
}

export class CreateDeliveryAgentError implements Action {
  readonly type = MasterActionTypes.CreateDeliveryAgentError;
  constructor(public payload: any) {}
}

export class LoadDeliveryAgent implements Action {
  readonly type = MasterActionTypes.LoadDeliveryAgent;
}

export class DeliveryAgentLoaded implements Action {
  readonly type = MasterActionTypes.DeliveryAgentLoaded;
  constructor(public payload: any) {}
}

export class DeliveryAgentLoadError implements Action {
  readonly type = MasterActionTypes.DeliveryAgentLoadError;
  constructor(public payload: any) {}
}

export class UpdateDeliveryAgent implements Action {
  readonly type = MasterActionTypes.UpdateDeliveryAgent;
  constructor(public payload: any, public id: string) {}
}

export class DeliveryAgentUpdated implements Action {
  readonly type = MasterActionTypes.DeliveryAgentUpdated;
  constructor(public payload: any) {}
}

export class UpdateDeliveryAgentError implements Action {
  readonly type = MasterActionTypes.UpdateDeliveryAgentError;
  constructor(public payload: any) {}
}

export class CreateAirportCode implements Action {
  readonly type = MasterActionTypes.CreateAirportCode;
  constructor(public payload: any) {}
}

export class AirportCodeCreated implements Action {
  readonly type = MasterActionTypes.AirportCodeCreated;
  constructor(public payload: any) {}
}

export class CreateAirportCodeError implements Action {
  readonly type = MasterActionTypes.CreateAirportCodeError;
  constructor(public payload: any) {}
}

export class LoadAirportCode implements Action {
  readonly type = MasterActionTypes.LoadAirportCode;
}

export class AirportCodeLoaded implements Action {
  readonly type = MasterActionTypes.AirportCodeLoaded;
  constructor(public payload: any) {}
}

export class AirportCodeLoadError implements Action {
  readonly type = MasterActionTypes.AirportCodeLoadError;
  constructor(public payload: any) {}
}

export class CreateCarrierCode implements Action {
  readonly type = MasterActionTypes.CreateCarrierCode;
  constructor(public payload: any) {}
}

export class CarrierCodeCreated implements Action {
  readonly type = MasterActionTypes.CarrierCodeCreated;
  constructor(public payload: any) {}
}

export class CreateCarrierCodeError implements Action {
  readonly type = MasterActionTypes.CreateCarrierCodeError;
  constructor(public payload: any) {}
}

export class LoadCarrierCode implements Action {
  readonly type = MasterActionTypes.LoadCarrierCode;
}

export class CarrierCodeLoaded implements Action {
  readonly type = MasterActionTypes.CarrierCodeLoaded;
  constructor(public payload: any) {}
}

export class CarrierCodeLoadError implements Action {
  readonly type = MasterActionTypes.CarrierCodeLoadError;
  constructor(public payload: any) {}
}

export class CreateDestinationAirport implements Action {
  readonly type = MasterActionTypes.CreateDestinationAirport;
  constructor(public payload: any) {}
}

export class DestinationAirportCreated implements Action {
  readonly type = MasterActionTypes.DestinationAirportCreated;
  constructor(public payload: any) {}
}

export class CreateDestinationAirportError implements Action {
  readonly type = MasterActionTypes.CreateDestinationAirportError;
  constructor(public payload: any) {}
}

export class LoadDestinationAirport implements Action {
  readonly type = MasterActionTypes.LoadDestinationAirport;
}

export class DestinationAirportLoaded implements Action {
  readonly type = MasterActionTypes.DestinationAirportLoaded;
  constructor(public payload: any) {}
}

export class DestinationAirportLoadError implements Action {
  readonly type = MasterActionTypes.DestinationAirportLoadError;
  constructor(public payload: any) {}
}

export class CreateAirline implements Action {
  readonly type = MasterActionTypes.CreateAirline;
  constructor(public payload: any, public key: string) {}
}

export class AirlineCreated implements Action {
  readonly type = MasterActionTypes.AirlineCreated;
  constructor(public payload: any) {}
}

export class CreateAirlineError implements Action {
  readonly type = MasterActionTypes.CreateAirlineError;
  constructor(public payload: any) {}
}

export class LoadAirline implements Action {
  readonly type = MasterActionTypes.LoadAirline;
}

export class AirlineLoaded implements Action {
  readonly type = MasterActionTypes.AirlineLoaded;
  constructor(public payload: any) {}
}

export class AirlineLoadError implements Action {
  readonly type = MasterActionTypes.AirlineLoadError;
  constructor(public payload: any) {}
}

export class DeleteEntity implements Action {
  readonly type = MasterActionTypes.DeleteEntity;
  constructor(public entityName: string, public id: string) {}
}

export class EntityDeleted implements Action {
  readonly type = MasterActionTypes.EntityDeleted;
  constructor(public entityName: string) {}
}

export class DeleteEntityError implements Action {
  readonly type = MasterActionTypes.DeleteEntityError;
  constructor(public payload: any) {}
}
export type MasterAction =
  | LoadMaster
  | MasterLoaded
  | MasterLoadError
  | CreateShipper
  | ShipperCreated
  | CreateShipperError
  | LoadShipper
  | ShipperLoaded
  | ShipperLoadError
  | UpdateShipper
  | ShipperUpdated
  | UpdateShipperError
  | ClearStore
  | CreateConsignee
  | ConsigneeCreated
  | CreateConsigneeError
  | LoadConsignee
  | ConsigneeLoaded
  | ConsigneeLoadError
  | UpdateConsignee
  | ConsigneeUpdated
  | UpdateConsigneeError
  | CreateNotify
  | NotifyCreated
  | CreateNotifyError
  | LoadNotify
  | NotifyLoaded
  | NotifyLoadError
  | UpdateNotify
  | NotifyUpdated
  | UpdateNotifyError
  | CreateDeliveryAgent
  | DeliveryAgentCreated
  | CreateDeliveryAgentError
  | LoadDeliveryAgent
  | DeliveryAgentLoaded
  | DeliveryAgentLoadError
  | UpdateDeliveryAgent
  | DeliveryAgentUpdated
  | UpdateDeliveryAgentError
  | CreateAirportCode
  | AirportCodeCreated
  | CreateAirportCodeError
  | LoadAirportCode
  | AirportCodeLoaded
  | AirportCodeLoadError
  | CreateCarrierCode
  | CarrierCodeCreated
  | CreateCarrierCodeError
  | LoadCarrierCode
  | CarrierCodeLoaded
  | CarrierCodeLoadError
  | CreateDestinationAirport
  | DestinationAirportCreated
  | CreateDestinationAirportError
  | LoadDestinationAirport
  | DestinationAirportLoaded
  | DestinationAirportLoadError
  | CreateAirline
  | AirlineCreated
  | CreateAirlineError
  | LoadAirline
  | AirlineLoaded
  | AirlineLoadError
  | DeleteEntity
  | EntityDeleted
  | DeleteEntityError;

export const fromMasterActions = {
  LoadMaster,
  MasterLoaded,
  MasterLoadError,
  CreateShipper,
  ShipperCreated,
  CreateShipperError,
  LoadShipper,
  ShipperLoaded,
  ShipperLoadError,
  UpdateShipper,
  ShipperUpdated,
  UpdateShipperError,
  ClearStore,
  CreateConsignee,
  ConsigneeCreated,
  CreateConsigneeError,
  LoadConsignee,
  ConsigneeLoaded,
  ConsigneeLoadError,
  UpdateConsignee,
  ConsigneeUpdated,
  UpdateConsigneeError,
  CreateNotify,
  NotifyCreated,
  CreateNotifyError,
  LoadNotify,
  NotifyLoaded,
  NotifyLoadError,
  UpdateNotify,
  NotifyUpdated,
  UpdateNotifyError,
  CreateDeliveryAgent,
  DeliveryAgentCreated,
  CreateDeliveryAgentError,
  LoadDeliveryAgent,
  DeliveryAgentLoaded,
  DeliveryAgentLoadError,
  UpdateDeliveryAgent,
  DeliveryAgentUpdated,
  UpdateDeliveryAgentError,
  CreateAirportCode,
  AirportCodeCreated,
  CreateAirportCodeError,
  LoadAirportCode,
  AirportCodeLoaded,
  AirportCodeLoadError,
  CreateCarrierCode,
  CarrierCodeCreated,
  CreateCarrierCodeError,
  LoadCarrierCode,
  CarrierCodeLoaded,
  CarrierCodeLoadError,
  CreateDestinationAirport,
  DestinationAirportCreated,
  CreateDestinationAirportError,
  LoadDestinationAirport,
  DestinationAirportLoaded,
  DestinationAirportLoadError,
  CreateAirline,
  AirlineCreated,
  CreateAirlineError,
  LoadAirline,
  AirlineLoaded,
  AirlineLoadError,
  DeleteEntity,
  EntityDeleted,
  DeleteEntityError,
};
